// extracted by mini-css-extract-plugin
export default {"TruncatedText":"TextCellRenderer_TruncatedText__SgqGz","MultiValueCell":"TextCellRenderer_MultiValueCell__rFZhZ","MoreCount":"TextCellRenderer_MoreCount__TtUwe"};